import ActionsForm from '@/shared/mixins/actionsForm'
import addFerramentasApr from '../addToolsApr/addToolsApr.vue'
import APRTemplateFerramentasRepository from '@/shared/http/repositories/business/aprTools'
import { toast, loading } from '@/shared/utils/UIHelper'

export default {
  props: ['aprId', 'revisao', 'aprTemplateReprovado', 'templateClonado'],
  name: 'toolsTable',
  components: {addFerramentasApr},
  mixins: [ActionsForm],
  data () {
    return {
      columTemplate: ['FERRAMENTAS', 'STATUS', 'TIPO DE MUDANÇA', 'DATA DE CADASTRO', ''],
      dataFerramentasTemplateAPR: [],
      dataFerramentaBusca: {}
    }
  },
  watch: {
    templateClonado (newValue) {
      if (newValue !== null || newValue !== undefined) {
        this.dataFerramentaBusca = {APRId: newValue.id, Revisao: newValue.revisao}
        APRTemplateFerramentasRepository.GetAPRTemplateFerramentasGrid(this.$refs.tableGridsTemplateAprFerramenta.pagingLimit, this.$refs.tableGridsTemplateAprFerramenta.pagingIndex, this.dataFerramentaBusca)
          .then((Response) => {
            loading.pop()
            this.dataFerramentasTemplateAPR = Response.data.data
          }).catch(Error => {
            loading.pop()
            toast.error('Erro ao carregar as informações')
          })
      }
    }
  },
  methods: {
    popUptAddFerramentas () {
      this.$refs['add-ferramentas'].show()
    },
    cancelarferramentas () {
      this.$refs['add-ferramentas'].hide()
    },
    onLoad (value) {
      if (this.revisao !== -1 || value != null) {
        loading.push()
        if (value !== undefined && value !== null) {
          this.dataFerramentaBusca = {APRId: this.aprId, Revisao: value}
          APRTemplateFerramentasRepository.GetAPRTemplateFerramentasGrid(this.$refs.tableGridsTemplateAprFerramenta.pagingLimit, this.$refs.tableGridsTemplateAprFerramenta.pagingIndex, this.dataFerramentaBusca)
            .then((Response) => {
              loading.pop()
              this.$refs.tableGridsTemplateAprFerramenta.LoadAllByData(Response)
              this.dataFerramentasTemplateAPR = Response.data.data
            }).catch(Error => {
              loading.pop()
            })
        } else {
          this.dataFerramentaBusca = {APRId: this.aprId, Revisao: this.revisao}
          APRTemplateFerramentasRepository.GetAPRTemplateFerramentasGrid(this.$refs.tableGridsTemplateAprFerramenta.pagingLimit, this.$refs.tableGridsTemplateAprFerramenta.pagingIndex, this.dataFerramentaBusca)
            .then((Response) => {
              loading.pop()
              this.$refs.tableGridsTemplateAprFerramenta.LoadAllByData(Response)
              this.dataFerramentasTemplateAPR = Response.data.data
            }).catch(Error => {
              loading.pop()
            })
        }
      }
    },
    AdicionarTableFerramentas (value) {
      this.dataFerramentasTemplateAPR.push(...value)
      this.$refs['add-ferramentas'].hide()
    },
    DeletePopup (value) {
      loading.push()
      if (value.AgEnvio !== undefined && value.AgEnvio !== null && value.AgEnvio !== false) {
        this.dataFerramentasTemplateAPR = this.dataFerramentasTemplateAPR.filter(ferramentaid => ferramentaid.ferramentaId !== value.ferramentaId)
        this.$emit('removerListaDeAlteracoesFerramentas', value)
        loading.pop()
      } else {
        for (let i = 0; i < this.dataFerramentasTemplateAPR.length; i++) {
          if (this.dataFerramentasTemplateAPR[i].ferramentasId === value.ferramentasId) {
            this.dataFerramentasTemplateAPR[i].statusAprovacao = null
            this.dataFerramentasTemplateAPR[i].statusAprovacaoDescricao = 'AG. ENVIO'
            this.dataFerramentasTemplateAPR[i].tipoMudanca = 'AG. ENVIO EXCLUSÃO'
            this.dataFerramentasTemplateAPR[i].dateCricaoFormatada = null
            let dados = {
              APRId: this.aprId,
              ferramenta: value.ferramentasId,
              APRAgAprovacaoId: value.arpTemplateAgAprovacaoId
            }
            this.$emit('excluirFerramentas', dados)
          }
        }
        loading.pop()
      }
      loading.pop()
    },
    salvarFerramentas (valeu) {
      this.$emit('salvarFerramentas', valeu)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/templateApr/components/toolsTable/toolsTable.js